module.exports = __webpack_public_path__ + "img/bg42.65136000.png";